var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20.5C17.1421 20.5 20.5 17.1421 20.5 13C20.5 8.85786 17.1421 5.5 13 5.5C8.85786 5.5 5.5 8.85786 5.5 13C5.5 17.1421 8.85786 20.5 13 20.5ZM13 22C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4C8.02944 4 4 8.02944 4 13C4 17.9706 8.02944 22 13 22Z",
    fill: "#0F0D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.75C13.4142 7.75 13.75 8.02474 13.75 8.36364V13.8864C13.75 14.2253 13.4142 14.5 13 14.5C12.5858 14.5 12.25 14.2253 12.25 13.8864V8.36364C12.25 8.02474 12.5858 7.75 13 7.75Z",
    fill: "#0F0D22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 8.48115C12.25 8.05175 12.6104 7.75 13 7.75C13.3896 7.75 13.75 8.05175 13.75 8.48115V13.7689C13.75 14.1983 13.3896 14.5 13 14.5C12.6104 14.5 12.25 14.1983 12.25 13.7689V8.48115ZM13 8.03725C12.6992 8.03725 12.5 8.26159 12.5 8.48115V13.7689C12.5 13.9884 12.6992 14.2128 13 14.2128C13.3008 14.2128 13.5 13.9884 13.5 13.7689V8.48115C13.5 8.26159 13.3008 8.03725 13 8.03725Z",
    fill: "#0F0D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16C13.4142 16 13.75 16.3358 13.75 16.75V17.5C13.75 17.9142 13.4142 18.25 13 18.25C12.5858 18.25 12.25 17.9142 12.25 17.5V16.75C12.25 16.3358 12.5858 16 13 16Z",
    fill: "#0F0D22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 16.7941C12.25 16.3555 12.5858 16 13 16C13.4142 16 13.75 16.3555 13.75 16.7941V17.4559C13.75 17.8945 13.4142 18.25 13 18.25C12.5858 18.25 12.25 17.8945 12.25 17.4559V16.7941ZM13 16.2647C12.7238 16.2647 12.5 16.5017 12.5 16.7941L12.5 17.4559C12.5 17.7483 12.7238 17.9853 13 17.9853C13.2761 17.9853 13.5 17.7483 13.5 17.4559V16.7941C13.5 16.5017 13.2761 16.2647 13 16.2647Z",
    fill: "#0F0D22"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.24f84f9f7a904715a7a3af00d7e1e723.svg";